import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {

    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','parentname', 'directchild', 'username'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/salesteam${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });        
    }

    ,
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("salesteam", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
    ,
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`salesteam/${encodeURIComponent(obj.userteamkey)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};